module.exports = __webpack_public_path__ + "media/images/blogapalooza2-b013566b237f039237f35ce12fbfa262.png";